import React from "react";

// 🏷️ ليبل جهة الطباعة على الطلب - نفس التسمية المستخدمة بواجهة المصمم
// (DesignerDashboard.js) عند اختيار جهة الطباعة: printChoice = internal / external.
// يظهر فقط للمدير والموظفات - ما يظهر لأي حساب ثاني (الورشة، المطبعة،
// المصمم، الشركاء...) حتى لو انعرض الكومبوننت بصفحة مشتركة
const ALLOWED_USERS = [
  "admin",
  "Baneen@123",
  "sara@123",
  "jumana@123",
  "maryam@123",
  "farah@123",
  "karina@123",
  "maysa@123",
  "rand@123",
];

const PRINT_CHOICE_STYLES = {
  internal: {
    label: "🏭 مطبعة الشركة",
    color: "#0d47a1",
    background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
    border: "#90caf9",
  },
  external: {
    label: "🚚 مطبعة خارجية",
    color: "#6a1b9a",
    background: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
    border: "#ce93d8",
  },
};

export default function PrintChoiceBadge({ order }) {
  const style = PRINT_CHOICE_STYLES[order?.printChoice];
  if (!style) return null;
  if (!ALLOWED_USERS.includes(localStorage.getItem("username"))) return null;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        margin: "0 6px",
        padding: "2px 10px",
        borderRadius: 999,
        border: `1px solid ${style.border}`,
        background: style.background,
        color: style.color,
        fontSize: "0.75rem",
        fontWeight: 800,
        lineHeight: 1.6,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
      }}
    >
      {style.label}
    </span>
  );
}
